import React, { useState } from "react";
import styles from "./ColorDropdown.module.css";

const colorOptions = [
  { label: "", value: "#FFFFFF" },
  { label: "", value: "#FF0000" },
  { label: "", value: "#FFFF00" },
  { label: "", value: "#00FF00" },
  { label: "", value: "#996600" },
  { label: "", value: "#AAAAAA" },
  { label: "", value: "#00FFFF" },
  { label: "", value: "#0000FF" },
  { label: "", value: "#FF00FF" },
  { label: "", value: "#000000" },
];

const ColorDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = colorOptions.find((opt) => opt.value === value);

  return (
    <div
      className={styles.dropdownWrapper}
      onClick={() => setIsOpen((prev) => !prev)}>
      <div className={styles.dropdownHeader}>
        <span
          className={styles.colorDot}
          style={{ backgroundColor: selectedOption?.value }}
        />
        {selectedOption?.label}
      </div>
      {isOpen && (
        <ul className={styles.dropdownList}>
          {colorOptions.map((opt) => (
            <li
              key={opt.value}
              className={styles.dropdownItem}
              onClick={(e) => {
                e.stopPropagation(); // prevent parent click
                onChange(opt.value);
                setIsOpen(false);
              }}>
              <span
                className={styles.colorDot}
                style={{ backgroundColor: opt.value }}
              />
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ColorDropdown;
